import React from "react";
import { Button } from "antd";
import { users } from '@services/api'


export default class AuthorizedPhoneItem extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            showDelete: false
        }
    }
    
    delete = () => {
        const {
            user_id,
            item: { id },
            getAuthorizedPhones
        } = this.props
        
        users.deleteAuthorizedPhone({ authorizedPhoneId: id })
        .then(() => {
            getAuthorizedPhones(user_id)
            this.setState({ showDelete: false })
        })
        .catch(() => {
            this.setState({ showDelete: false })
            alert('עדכון נכשל')
        })
    }

    render() {
        const { item } = this.props
        const { showDelete } = this.state
        return (
            <div style={{ ...style.listItem }}>
                <div style={{ width: '30%' }}>
                    <span>{`${item.name}`}</span>
                </div>
                <div style={{ width: '30%' }}>
                    <span>{`0${item.phone}`}</span>
                </div>
                <div style={{ width: '20%' }}>
                    <Button onClick={this.props.toggleEdit}>{"עריכה"}</Button>
                </div>
                <div style={{ width: '20%', ...style.last }}>
                    {!showDelete &&
                    <Button onClick={() => this.setState({ showDelete: true })}>{"מחיקה"}</Button>}
                    {showDelete &&
                    <div style={{ marginLeft: '12px' }}>
                        <span style={{ marginLeft: '7px' }}>למחוק?</span>
                        <span
                            style={{ ...style.textBtn, marginLeft: '7px' }}
                            onClick={() => this.setState({ showDelete: false })}
                        >
                            {"לא"}
                        </span>
                        <span
                            style={{ ...style.textBtn  }}
                            onClick={this.delete}
                        >
                            {"כן"}
                        </span>
                    </div>}
                </div>
            </div>
        )
    }
}

const style = {
    listItem : {
        display: 'flex',
        justifyContent: 'space-between', 
        alignSelf: 'stretch',
        padding: '10px 10px 10px 0'
    },
    last : {
        display: 'flex',
        justifyContent: 'end'
    },
    textBtn: {
        cursor: 'pointer',
        textDecoration: 'underline'
    }
}



